var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.085 19c0 .55.46 1 1.021 1h4.085c.562 0 1.022-.45 1.022-1v-1H4.085v1zM7.15 0C3.207 0 0 3.14 0 7c0 2.38 1.215 4.47 3.064 5.74V15c0 .55.46 1 1.021 1h6.128c.561 0 1.021-.45 1.021-1v-2.26c1.849-1.27 3.064-3.36 3.064-5.74 0-3.86-3.207-7-7.15-7zm2.91 11.1l-.868.6V14H5.106v-2.3l-.868-.6C2.86 10.16 2.043 8.63 2.043 7c0-2.76 2.287-5 5.106-5s5.106 2.24 5.106 5c0 1.63-.817 3.16-2.195 4.1z",
    id: "lightbulb__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#ff8c00",
    xlinkHref: "#lightbulb__a",
    transform: "translate(.32)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.d83d47d1ad1bbe65131c9f5582ad294e.svg";
export { ForwardRef as ReactComponent };